import Form from 'components/Form';
import { IPatientInfo } from 'apis/admin/type';
import { IFormRegister } from 'routes/Main/type';
import MuiTextField from 'components/Form/MuiTextField';

import RowContainer from '../../components/RowContainer';
import RowContent from '../../components/RowContent';

interface Props extends IFormRegister {
  disabled?: boolean;
  nurseName: string;
  patientInfo: IPatientInfo;
  setOpDate: (opDate: string) => void;
}

const PatientInfo = (props: Props) => {
  const { patientInfo, register } = props;
  const {
    patient_id,
    name,
    gender,
    age,
    height,
    blood,
    weight,
    department,
    ward,
    room,
    admin_hod,
    disease_main,
  } = patientInfo;

  const staffs = [
    {
      title: 'Bác sĩ phẫu thuật',
      variable: 'surgery_information.operating_surgeon',
    },
    { title: 'Trợ lý', variable: 'surgery_information.assistant' },
    { title: 'Y tá phòng mổ', variable: 'surgery_information.scrubbing_nurse' },
    {
      title: 'Y tá  lưu động',
      variable: 'surgery_information.circulating_nurse',
    },
  ];

  return (
    <RowContainer xs={12}>
      <RowContent title="Tên bệnh nhân" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={name} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Mã số đăng ký" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={patient_id} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Tuổi" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={age} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Giới tính" titleRatio={1} childrenRatio={2}>
        <Form.MuiRadioGroup
          i18nKey="GENDER"
          values={[1, 2]}
          value={gender}
          defaultValue={gender}
        />
      </RowContent>
      <RowContent title="Khu vực" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={ward} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Phòng" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={room} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Khoa điều trị" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={department} InputProps={{ readOnly: true }} />
      </RowContent>

      <RowContent title="HOD" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={admin_hod} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Chiều cao" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={height} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Cân nặng" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={weight} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Nhóm máu" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField value={blood} InputProps={{ readOnly: true }} />
      </RowContent>
      <RowContent title="Chẩn đoán" titleRatio={1} childrenRatio={2}>
        <Form.MuiTextField
          value={disease_main.disease_eng}
          InputProps={{ readOnly: true }}
        />
      </RowContent>

      {staffs.map(({ title, variable }, _) => (
        <RowContent
          key={variable}
          title={title}
          titleRatio={1}
          childrenRatio={2}
        >
          <MuiTextField {...register(variable)} required={false} />
        </RowContent>
      ))}
    </RowContainer>
  );
};

export default PatientInfo;
